import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { MessageField } from 'widgets/MessageField'
import { useChatbotContext, useChatbotDialogContext } from 'pages/chatbot/context'
import { ChatbotTestButton, AgentTestFollowupButton } from 'pages/chatbot/ui/ChatbotButtons'
import { CompletedAlert, MessageBoxWrapper, SaveAndRestartAlert } from './MessageBoxWrapper'
import styles from './styles.module.scss'

export const MessageBox = observer(() => {
  const chatbot = useChatbotContext()
  const dialog = useChatbotDialogContext()
  const { firstMessage } = chatbot.model

  const isDisabled = chatbot.dirty || chatbot.locked
  const isCompletedAlertDisabled = chatbot.id === null || chatbot.locked || dialog.loading
  const isSaveAndRestartAlertDisabled =
    chatbot.id === null || chatbot.locked || dialog.completed || dialog.loading

  const handleAlertAction = () => {
    if (chatbot.dirty) {
      chatbot.updateChatbot().then((updated) => {
        if (updated) dialog.restart(firstMessage.isAutoConvType)
      })
    } else {
      dialog.restart(firstMessage.isAutoConvType)
    }
  }

  return (
    <MessageBoxWrapper dialog={dialog} disabled={isDisabled}>
      {!chatbot.dirty && (
        <Box display='flex' gap={1} marginBottom={'5px'}>
          <div className={styles.dialogHeaderTestButton}>
            <ChatbotTestButton size='small' />
          </div>
          <div className={styles.dialogHeaderTestButton}>
            <AgentTestFollowupButton />
          </div>
        </Box>
      )}
      <CompletedAlert
        handleAction={handleAlertAction}
        disabled={isCompletedAlertDisabled}
        dialog={dialog}
      />
      <SaveAndRestartAlert
        handleAction={handleAlertAction}
        disabled={isSaveAndRestartAlertDisabled}
        dialog={dialog}
        isExistChanges={chatbot.dirty}
      />
      <MessageField messageFieldStore={dialog.message} />
    </MessageBoxWrapper>
  )
})
